import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles'
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import _, { map } from 'lodash';
import classNames from 'classnames';
import SearchField from '../../components/SearchField';
import School from '../../components/School';
// import Checklist from '../../components/Checklist';
import Loader from '../../components/Loader';
import SearchNoResults from '../../components/SearchNoResults';
/* eslint-disable import/no-named-as-default */
import Button from '../../components/Button';
// import Map from '../../components/Map';
import Mapbox from '../../components/Mapbox';
import FilterSelect from '../../components/FilterSelect';
import { withRtl } from '../../components/hoc';
import style from '../logged-in/LoggedIn.scss'; // eslint-disable-line css-modules/no-unused-class
import { getSchools } from '../../actions/schools';
import { getFilters } from '../../actions/filters';
import setPage, { resetPagination } from '../../actions/pagination';
import { addParameterAndSearch } from '../../actions/addParameter';
import schoolsToMarker from '../../services/schoolsToMarker';
import Default, { Mobile } from '../../utils/mediaQueries';
import SearchAndFilter from '../../components/SearchAndFilter';
import { getSchoolsAutocomplete } from '../../actions/autocomplete';
import { setLoggedOutAddress, clearLoggedOutAddress } from '../../actions/student';
import messages from '../../locale/messages';
import HomeIcon from '../../components/icons/Home';
import CloseIcon from '../../components/icons/Close';
import history from '../../history';
import GOATSearchContainer from '../../containers/GOATSearchContainer';
import analytics from '../../services/analytics';
import { processNameToShortCode, customisedIntlFormatMessage } from '../../utils/helpers';

class Home extends Component {
  static propTypes = {
    filters: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
      }),
    ).isRequired,
    filtersLoaded: PropTypes.bool.isRequired,
    filtersLoading: PropTypes.bool.isRequired,
    schools: PropTypes.shape({
      autocomplete: PropTypes.shape({
        autocompleteSchools: PropTypes.arrayOf(PropTypes.string),
        autocompleteSchoolsId: PropTypes.arrayOf(PropTypes.number),
        autocompleteSchoolsDbn: PropTypes.arrayOf(PropTypes.string),
      }).isRequired,
      optionsDict: PropTypes.shape({}).isRequired,
      loaded: PropTypes.bool.isRequired,
      loading: PropTypes.bool.isRequired,
      normalSchools: PropTypes.shape(),
    }).isRequired,
    intl: PropTypes.shape({
      locale: PropTypes.string,
      formatMessage: PropTypes.func,
    }).isRequired,
    isRtl: PropTypes.bool,
    userInfo: PropTypes.shape({
      set: PropTypes.bool,
      latlng: PropTypes.shape({}),
      formattedAddress: PropTypes.string,
    }).isRequired,
    page: PropTypes.shape({ page: PropTypes.number.isRequired, last: PropTypes.bool.isRequired }).isRequired,
    dispatch: PropTypes.func.isRequired,
    pathname: PropTypes.string.isRequired,
    /*
      TODO CREATE PAGINATION
      isFetching: PropTypes.bool.isRequired,
      // onLoadMoreClick: PropTypes.func.isRequired,
      nextPageUrl: PropTypes.string,
      loadingLabel: PropTypes.string.isRequired,
    */
  };

  static defaultProps = {
    isRtl: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      hoveredSchool: false,
      mobileMapIsOpen: false,
      isComingFromMobileMap: false,
      currentSchoolDetail: null,
      currentProgramId: 0,
      latLng: '',
      loaded: false,
    };

    // sk: I can't believe we can't get these in as URL params from the routes?
    const parts = props.pathname.split('/');
    this.processName = parts.pop() || parts.pop(); // handle potential trailing slash
    this.admissionProcess = processNameToShortCode({ processName: this.processName });
  }

  componentDidMount() {
    const { dispatch } = this.props;
    const { loaded } = this.state;
    if (loaded) {
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const filters_applied = urlParams.get('filters_applied')
    if (!filters_applied) {
      // Once component is mounted then remove the old search text MYS-1009
      delete this.props.schools.optionsDict['q'];
      delete this.props.schools.optionsDict['search'];
      this.props.schools.autocomplete['autocompleteSchools'] = [];
    }
    const prediction = urlParams.get('prediction')
    if (prediction) {
      this.handlePlaceChange(JSON.parse(prediction))
    }

    const clear_address = urlParams.get('clear_address')
    if (clear_address) {
      this.handleClearAddress()
    }

    const getSchoolsTask = dispatch(getSchools({ processName: this.processName })).catch(error => {
      console.error('Failed to getSchools', error);
    });
    const getFiltersTask = dispatch(getFilters({ processName: this.processName })).catch(error => {
      console.error('Failed to getFilters', error);
    });

    Promise.all([
      //
      getSchoolsTask,
      getFiltersTask,
    ])
      .then(() => {
        this.setState({
          ...this.state,
          loaded: true,
        });
      })
      .catch(error => {
        console.error('Error', error);
      });
  }

  // componentWillReceiveProps(nextProps) {
  //   if (nextProps.schools.optionsDict !== this.props.schools.optionsDict) {
  //     this.props.getSchools();
  //   }
  // }

  componentDidUpdate(prevProps) {
    // Keep the mobile map mounted once it's been opened: toggling back to the list
    // CSS-hides it instead of unmounting, so reopening doesn't re-fire a map-sessions
    // beacon or hit the broken reuse path. (Mount condition is in render.)
    if (this.state.mobileMapIsOpen && !this.state.mobileMapHasOpened) {
      this.setState({ mobileMapHasOpened: true });
    }
    let { pathname } = history.location;
    const { schools, intl, dispatch } = this.props;
    const { latLng } = this.state;
    // avoiding filters when user click on the autocomplete results (pathname == prevProps.pathname) mys-779
    if (prevProps.schools.optionsDict !== schools.optionsDict && pathname == prevProps.pathname) {
      if (latLng) {
        dispatch(getSchools({ latLng, processName: this.processName }));
      } else {
        dispatch(getSchools({ processName: this.processName }));
      }
    }

    if (prevProps.intl.locale !== intl.locale) {
      if (latLng) {
        dispatch(getSchools({ latLng, processName: this.processName }));
      } else {
        dispatch(getSchools({ processName: this.processName }));
      }
      dispatch(getFilters({ processName: this.processName }));
    }
  }

  // onMobileToggleFunction = () => (this.state.mobileRender === SCHOOLS ? this.mobileShowMap : this.mobileShowSchools);

  getBoundingSchoolPins = _.debounce((neCoords, swCoords) => {
    const { dispatch, userInfo } = this.props;
    dispatch(
      getSchools({
        processName: this.processName,
        latLng: userInfo && userInfo.latlng ? `longitude=${userInfo.latlng.lng}&latitude=${userInfo.latlng.lat}&` : '',
        mapBounds: `ne_coords=${neCoords.join(',')}&sw_coords=${swCoords.join(',')}&`,
      }),
    );
  }, 1500);

  getMarkers = () => {
    const { normalSchools, loading, loaded } = this.props.schools;
    let markers = [];
    if (loading) {
      return markers;
    } else if (loaded) {
      markers = schoolsToMarker(normalSchools, normalSchools.result);
    }
    return markers;
  };

  getFilters = () => {
    const { filters, filtersLoading, filtersLoaded } = this.props;
    const urlParams = new URLSearchParams(window.location.search);
    const filters_applied = urlParams.get('filters_applied')
    let optionsDict = null;
    if (filters_applied) {
      optionsDict = this.props.schools.optionsDict;
    }
    let filtersLoad = null;
    if (filtersLoading) {
      filtersLoad = (
        <li className={style.listItem}>
          <Loader />
        </li>
      );
      return filtersLoad;
    } else if (filtersLoaded) {
      filtersLoad = (
        <div className={style.filters}>
          {filters.map(filter => {
            if (optionsDict) {
              map(filter.optionGroups, options => {
                map(options.options, indOptionSet => {
                  if (optionsDict.hasOwnProperty(indOptionSet.id) && optionsDict[indOptionSet.id].includes(indOptionSet.value)) {
                    indOptionSet.selected = true;
                    indOptionSet.true = {
                      id: indOptionSet.value,
                      label: indOptionSet.label,
                      section: indOptionSet.id,
                    }
                  }
                })
              })
            }
            const allOptions = filter.optionGroups.map(({ options }) => options);
            const selected = _.flattenDeep(allOptions)
              // eslint-disable-next-line no-shadow
              .map(({ selected }) => selected)
              .filter(n => n);

            return (
              <FilterSelect
                key={filter.label}
                label={filter.label}
                optionGroups={filter.optionGroups}
                apply={this.handleApplyFilter}
                reset={this.handleResetFilter}
                selected={selected.length}
                admissionProcess={this.admissionProcess}
              />
            );
          })}
        </div>
      );
    }
    return filtersLoad;
  };

  getAddressAutocomplete = () => {
    const { userInfo, intl } = this.props;
    const { autocompleteSchools } = this.props.schools.autocomplete;
    return (
      <Fragment>
        <div className={style.addressAutocompleteContainer + ' exclude-print'}>
          <div className={style.homeIconContainer}>
            <HomeIcon size={25} fill="#052B52" />
          </div>
          <GOATSearchContainer
            placeholder={customisedIntlFormatMessage(intl, messages.generalStringYourChildsAddress)}
            ariaLabel={customisedIntlFormatMessage(intl, messages.generalStringYourChildsAddress)}
            onPlaceChange={this.handlePlaceChange}
            // handlePlaceChangeGooglePlaces={this.handlePlaceChangeGooglePlaces}
            hidden={userInfo.set}
          />
          {userInfo.set && (
            <div className={style.userAddress}>
              <span>{userInfo.formattedAddress}</span>
              <div className={style.clearAddressWrapper}>
                <CloseIcon
                  size={12}
                  fill="#024cbc"
                  onClick={this.handleClearAddress}
                  aria-label={customisedIntlFormatMessage(intl, messages.generalStringClearAddress)}
                />
              </div>
            </div>
          )}
        </div>
        <SearchField
          onChangeValue={this.handleSearchfieldAutocomplete}
          onClick={this.showAutocompleteSchoolDetail}
          placeholder={messages.searchfieldPlaceholderSchools}
          autocomplete
          onSearch={this.handleApplyFilter}
          items={autocompleteSchools}
          user={userInfo}
          display={this.state.string || this.props.schools.optionsDict.search && this.props.schools.optionsDict.search[0]}
        />
        {this.getFilters()}
      </Fragment>
    );
  };

  handlePlaceChange = ({ prediction }) => {
    const { lat, lng } = prediction;
    const { dispatch } = this.props;

    dispatch(setLoggedOutAddress({ lat, lng }, prediction.description));

    // MUST have &
    // TODO Using state instead of redux because we need the proper string
    // and time is a factor
    const latLng = `latitude=${lat}&longitude=${lng}&`;
    this.setState({
      ...this.state,
      latLng,
    });

    dispatch(
      getSchools({
        latLng,
        processName: this.processName,
      }),
    );
  };

  previousPage = () => {
    const { dispatch } = this.props;
    const { latLng } = this.state;
    dispatch(setPage('down'));
    dispatch(
      getSchools({
        latLng,
        processName: this.processName,
      }),
    );
  };

  nextPage = () => {
    const { dispatch } = this.props;
    const { latLng } = this.state;
    dispatch(setPage('up'));
    dispatch(
      getSchools({
        latLng,
        processName: this.processName,
      }),
    );
  };

  handleCloseDetailView = () => {
    const { isComingFromMobileMap } = this.state;
    this.state.currentSchoolDetail = null;
    this.setState({
      ...this.state,
      currentSchoolDetail: null,
      currentProgramId: 0,
      mobileMapIsOpen: !!isComingFromMobileMap,
      isComingFromMobileMap: false,
    });

    const { pathname } = history.location;
    history.push(pathname);
  };

  handleProgramClick = (id, schoolId, dbn) => {
    const { currentProgramId, currentSchoolDetail, mobileMapIsOpen, isComingFromMobileMap } = this.state;
    // sk: if we are in school detail
    // all user interactions are intentional
    if (id === currentProgramId) {
      this.setState({
        ...this.state,
        currentProgramId: id,
        mobileMapIsOpen: false,
        isComingFromMobileMap: !!mobileMapIsOpen || isComingFromMobileMap,
      });
    }

    if (currentSchoolDetail !== schoolId) {
      const { pathname } = history.location;
      history.push(`${pathname}?dbn=${dbn}`);
    }

    document.body.style.overflow = 'initial';
  };

  handleSchoolClick = (id, dbn) => {
    const { currentSchoolDetail, currentProgramId, mobileMapIsOpen, isComingFromMobileMap } = this.state;
    if (currentSchoolDetail === id) {
      // CURRENT SCHOOL
      if (currentProgramId) {
        // clicking a school map title AND we have a program open
        this.setState({
          ...this.state,
          currentProgramId: 0,
          mobileMapIsOpen: false,
          isComingFromMobileMap: !!mobileMapIsOpen || isComingFromMobileMap,
        });
      } else {
        // clicking the school map title when school card is open and no program is open
        this.setState({
          ...this.state,
          currentSchoolDetail: id,
          currentProgramId: 1,
          mobileMapIsOpen: false,
          isComingFromMobileMap: !!mobileMapIsOpen || isComingFromMobileMap,
        });
      }
    } else {
      const { pathname } = history.location;
      history.push(`${pathname}?dbn=${dbn}`);
      this.setState({
        ...this.state,
        currentSchoolDetail: id,
        currentProgramId: 0,
        mobileMapIsOpen: false,
        isComingFromMobileMap: !!mobileMapIsOpen || isComingFromMobileMap,
      });
      setTimeout(function () {
        window.scrollTo(0, 0)
      }, 1000);
    }
    document.body.style.overflow = 'initial';
  };

  handleApplyFilter = ({ optionGroups }) => {
    const { dispatch } = this.props;
    this.handleCloseDetailView();
    if (optionGroups.search) {
      this.setState({
        ...this.state,
        string: optionGroups.search[0],
      });
    }
    dispatch(addParameterAndSearch(optionGroups));
  };

  handleResetFilter = () => {
    const { dispatch } = this.props;
    dispatch(resetPagination());
  };

  handleApplyFilters = ({ filters }) => {
    const { dispatch } = this.props;
    const realOptionGroups = [];
    filters.map(({ optionGroups }) =>
      optionGroups.map(item => {
        realOptionGroups.push(item);
        return item;
      }),
    );

    dispatch(addParameterAndSearch(realOptionGroups));
  };

  // handleResetFilters = ({ filters }) => {};

  mapPlaceholder = () => {
    this.mapClick();
  };

  mapClick = () => { };

  handleToggleMapForMobileView = ({ isOpen }) => {
    this.setState({
      ...this.state,
      mobileMapIsOpen: isOpen,
    });
  };

  handleShow = () => { };

  handleSearchfieldAutocomplete = _.debounce(string => {
    const {
      dispatch,
      schools: { optionsDict: options },
    } = this.props;
    const { latLng } = this.state;
    dispatch(
      getSchoolsAutocomplete({
        query: string,
        latLng,
        options,
        processName: this.processName,
      }),
    );
  }, 1000);

  showAutocompleteSchoolDetail = string => {
    this.handleCloseDetailView();
    const { schools, dispatch } = this.props;
    const { autocompleteSchools, autocompleteSchoolsDbn } = schools.autocomplete;
    const dbn = autocompleteSchoolsDbn[autocompleteSchools.indexOf(string)];
    analytics({
      eventLabel: 'autocompleteSchoolClick',
      dataDictionary: {
        schoolDbn: `${dbn}`,
        schoolName: `${string}`,
        loggedIn: false,
      },
    });

    dispatch(
      getSchools({
        extra: `/${dbn}`,
        isAutoComplete: true,
        processName: this.processName,
      }),
    );
    let { pathname } = history.location;
    if (pathname.substr(-1) === '/') {
      pathname = pathname.substr(0, pathname.length - 1);
    }
    history.push(`${pathname}/${dbn}`);
  };
  handleClearAddress = () => {
    const { dispatch } = this.props;
    dispatch(clearLoggedOutAddress());
    this.setState({
      ...this.state,
      latLng: '',
    });
    dispatch(getSchools({ processName: this.processName }));
  };

  renderSchools = () => {
    const { normalSchools, loading, loaded } = this.props.schools;
    const { page, isRtl, intl } = this.props;
    const { currentSchoolDetail, currentProgramId } = this.state;
    let load = null;
    window.scrollTo(0, 0);
    if (loading) {
      load = (
        <li className={style.listItem}>
          <Loader />
        </li>
      );
      return load;
    } else if (loaded) {
      load = (
        <li className={classNames(style.listItem, style.listItemPagination) + ' exclude-print'}>
          <button
            className={classNames('button', style.paginationButton, style.paginationButtonPrevious, {
              [style.paginationButtonDisabled]: page.page === 1,
            })}
            aria-label={customisedIntlFormatMessage(intl, messages.buttonSchoolsSearchPrevious)}
            onClick={this.previousPage}
            disabled={page.page === 1}
          >
            <i className={`icon-caret-${isRtl ? 'right' : 'left'}`} />
          </button>
          <button
            className={classNames('button', style.paginationButton, style.paginationButtonNext, {
              [style.paginationButtonDisabled]: page.last,
            })}
            aria-label={customisedIntlFormatMessage(intl, messages.buttonSchoolsSearchNext)}
            onClick={this.nextPage}
            disabled={page.last}
          >
            <i className={`icon-caret-${isRtl ? 'left' : 'right'}`} />
          </button>
        </li>
      );
    }

    if (!normalSchools.result.length) {
      return <SearchNoResults />;
    }

    if (currentSchoolDetail !== null && currentSchoolDetail in normalSchools.entities.school) {
      return (
        <ul className={style.list}>
          <li key="detail" className={style.listItem}>
            <School
              {...normalSchools.entities.school[currentSchoolDetail]}
              onClick={this.handleSchoolClick}
              showDetails
              headerOpen={!currentProgramId}
              programClick={this.handleProgramClick}
              programOpen={currentProgramId}
              admissionProcess={this.admissionProcess}
            />
          </li>
        </ul>
      );
    }

    return (
      <ul className={style.list}>
        {normalSchools.result.map(id => (
          <li
            key={id}
            className={style.listItem}
            ref={el => {
              this[id] = el;
            }}
          >
            <School
              {...normalSchools.entities.school[id]}
              onClick={this.handleSchoolClick}
              programClick={this.handleProgramClick}
            />
          </li>
        ))}
        {load}
      </ul>
    );
  };

  render() {
    const { filters, userInfo, intl, user } = this.props;
    const { mobileMapIsOpen, currentSchoolDetail, isComingFromMobileMap, loaded } = this.state;
    const { autocompleteSchools } = this.props.schools.autocomplete;
    const zonedSchoolLoginRequiredText = this.props.schools.zonedSchoolLoginRequiredText;
    const sidebarClasses = [style.sidebar, style.sidebarLoggedOut];
    const mapClasses = [style.map];
    if (mobileMapIsOpen) {
      sidebarClasses.push(style.sidebarMapIsClicked);
      mapClasses.push(style.mapMapIsClicked);
    }
    const isLoggedIn = user && user.userId && user.userId !== "None" ? true : false;
    let loginAlertForAffiliatedSchools;
    let loginAlertForAllSchools
    if (this.admissionProcess == 'SR' && !isLoggedIn) {
      loginAlertForAffiliatedSchools = (
        <div className={style.alertBox}>
          <span className={style.alertBoxText}>{customisedIntlFormatMessage(intl, messages.loginAlertForAffiliatedSchoolsMessage)}</span>
        </div>
      );
    }else if (!isLoggedIn) {
      loginAlertForAllSchools = (
        <div className={style.alertBox}>
          <span className={style.alertBoxText}>{customisedIntlFormatMessage(intl, messages.loginAlertForAllSchoolsMessage)}</span>
        </div>
      );
    }

    let loginAlertForZonedSchools;
    if (zonedSchoolLoginRequiredText && !isLoggedIn) {
      loginAlertForZonedSchools = (
        <div className={style.alertBox}>
          <span className={style.alertBoxText}> {zonedSchoolLoginRequiredText} </span>
        </div>
      );
    }

    if (!loaded) {
      return <Loader text={customisedIntlFormatMessage(intl, messages.generalStringLoading)} />;
    }

    const backButtonLabel = isComingFromMobileMap
      ? customisedIntlFormatMessage(intl, messages.generalStringBackToMap)
      : customisedIntlFormatMessage(intl, messages.generalStringBackToList);

    const mapProps = {
      markers: this.getMarkers(),
      popupClickHandlers: {
        onSchoolNameClick: this.handleSchoolClick,
        onProgramClick: this.handleProgramClick,
      },
      user: userInfo,
      isLoggedOutUser: true,
      currentSchoolDetail,
      admissionProcess: this.admissionProcess,
      getBoundingSchoolPins: this.getBoundingSchoolPins,
      // re-fit the map when the user pages through results (see Mapbox.componentDidUpdate)
      page: this.props.page.page,
    };

    return (
      <main className={style.root} role="presentation">
        <Mobile>
              <SearchAndFilter
                filters={filters}
                toggleMap={this.handleToggleMapForMobileView}
                mapIsOpen={mobileMapIsOpen}
                apply={this.handleApplyFilters}
                searchfieldItems={autocompleteSchools}
                searchfieldOnClick={this.showAutocompleteSchoolDetail}
                searchfieldOnSearch={this.handleApplyFilter}
                searchfieldOnChangeValue={this.handleSearchfieldAutocomplete}
                user={userInfo}
                handlePlaceChange={this.handlePlaceChange}
                handleClearAddress={this.handleClearAddress}
                display={this.state.string || this.props.schools.optionsDict.search && this.props.schools.optionsDict.search[0]}
              />
            </Mobile>
        <div className={style.flexRoot}>
          <div className={classNames(...sidebarClasses)}>
            {loginAlertForAffiliatedSchools}
            {loginAlertForZonedSchools}
            {loginAlertForAllSchools}
            <Default>{this.getAddressAutocomplete()}</Default>
            {currentSchoolDetail && (
              <div className={style.backButtonWrapper}>
                <Default>
                  <Button
                    onClick={this.handleCloseDetailView}
                    iconLeft="arrow-left"
                    aria-label={customisedIntlFormatMessage(intl, messages.generalStringBackToList)}
                    label={customisedIntlFormatMessage(intl, messages.generalStringBackToList)}
                    iconColor="#4ee4b3"
                    full
                    large
                  />
                </Default>
                <Mobile>
                  <Button
                    onClick={this.handleCloseDetailView}
                    iconLeft="arrow-left"
                    aria-label={backButtonLabel}
                    label={backButtonLabel}
                    iconColor="#4ee4b3"
                    full
                    large
                  />
                </Mobile>
              </div>
            )}
            {this.renderSchools()}
          </div>
          <div className={classNames(...mapClasses)}>
            <Default>
              <Mapbox {...mapProps} />
            </Default>
            <Mobile>
              {/* Lazy-mount the mobile map: don't instantiate mapbox-gl (a billable map
                  load) until the user first opens the map view. Once opened, keep it
                  mounted (visibility is CSS-toggled) so reopening doesn't re-initialize a
                  new map — avoids an extra map-sessions beacon and the broken-reuse path. */}
              {(mobileMapIsOpen || this.state.mobileMapHasOpened) && <Mapbox {...mapProps} mobile />}
            </Mobile>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = ({ schools, filters, page, user }) => ({
  schools,
  ...filters,
  page,
  userInfo: user.loggedOutUser,
  user,
  // admissionProcesses,
});

export default compose(
  //
  injectIntl,
  withRtl(style),
  withStyles(style),
  connect(mapStateToProps),
)(Home);
